<template lang="html">
    <div :id="id" :class="[(enabled && !muted) ?  '' : 'no-audio', id]">
        <div class="led-wrapper" v-if="horizontal">
            <div class="led h-2"></div>
        </div>
        <div class="led-wrapper w-full h-full bg-gray-200 flex items-end" v-else>
            <div class="led w-full vertical"></div>
        </div>
    </div>
</template>
<script>
import { setupSoundMeter } from 'webaudio/soundmeter';

export default {
    props: { 
        id: String,
        stream: MediaStream,
        horizontal: Boolean, 
        muted: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            enabled: false,
        }
    },
    watch: {
        stream: function () {
            setupSoundMeter("#" + this.id, this.stream, this.id, this.horizontal ? 'bar' : 'tower', (amount) => {
                this.$emit("speaking", amount)
            })
            this.checkStream();
        }
    },
    methods: {
        checkStream() {
            // We disable the enabled attribute for horizontal meters
            // this is only because those meters are set outside of vue
            if (this.horizontal){
                this.enabled = true;
                return
            } 
            // check if stream has enabled tracks, if it doesnt then put a grey overlay on the led
            if (this.stream == null || this.stream.getAudioTracks().length == 0) {
                this.enabled = false;
            } else {
                this.enabled = true;
            }
        },
    },
    mounted() {
        this.checkStream()
    }
}
</script>
<style lang="css">
.dark .no-audio .led-wrapper{
    background: red;
}
.no-audio .led-wrapper{
    background: red;
}
</style>
